import { render, staticRenderFns } from "./BenefitGrantDialog.vue?vue&type=template&id=29f401b2&scoped=true"
import script from "./BenefitGrantDialog.vue?vue&type=script&lang=js"
export * from "./BenefitGrantDialog.vue?vue&type=script&lang=js"
import style0 from "./BenefitGrantDialog.vue?vue&type=style&index=0&id=29f401b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f401b2",
  null
  
)

export default component.exports